export default "__VITE_ASSET__CPIpGF3s__"